var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.app},[_c('GameContainer',_vm._g(_vm._b({attrs:{"gameComponent":"RiddleGame","fixedAspectRatio":false,"hasTimer":"","reloadOnRetry":""}},'GameContainer',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }